import styled, { keyframes } from "styled-components";

const headShakeAnimation = keyframes`
  0% { transform: translateX(0); }
  6.5% { transform: translateX(-2px) rotateY(-2deg); }
  18.5% { transform: translateX(1px) rotateY(1deg); }
  31.5% { transform: translateX(-1px) rotateY(-1deg); }
  43.5% { transform: translateX(0.5px) rotateY(0.5deg); }
  50% { transform: translateX(0); }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 35px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  min-width: fit-content;
`;

export const WinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${({ theme }) => theme.colors.dataViz.winnerTextColor};
`;

export const WinnerDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.dataViz.winnerDotColor};
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
`;

export const Share = styled.div`
  height: 40px;
  display: grid;
  place-content: center;

  padding: 10px;
  border: 1px solid #abb4f4;
  border-radius: 4px;
  cursor: pointer;
  &:hover > svg {
    animation: ${headShakeAnimation} 1s both;
  }
`;

export const Print = styled.div`
  height: 40px;
  display: grid;
  place-content: center;

  padding: 10px;
  border: 1px solid #abb4f4;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  &:hover > svg {
    animation: ${headShakeAnimation} 1s both;
  }
`;

export const Dots = styled.div`
  cursor: pointer;
  position: relative;

  > svg {
    transform: scale(1);
    transition: transform 0.2s ease-in-out;
  }
  &:hover > svg {
    transform: scale(1.2);
  }
`;

export const TeamPopUp = styled.div`
  width: ${({ isFeedback }) => (isFeedback ? "190px" : "220px")};
  background: #1e1f43;
  border-radius: 4px;
  border: 1px solid #4e4f87;
  cursor: default;
  opacity: 1;
  height: auto;
  max-height: ${({ isFeedback }) => (isFeedback ? "200px" : "500px")};
  min-height: ${({ isFeedback }) => (isFeedback ? "" : "88px")};
  transition: opacity 0.3s ease-in-out;
`;

export const TeamPopUpItem = styled.ul`
  cursor: pointer;
  padding: 15px;
  background: ${(props) => (props.isAdd ? "rgba(255, 255, 255, 0.10)" : "#1e1f43")};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  & li {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    & a {
      color: white;
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 600;
    }
  }
`;
